import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { CheckCircle } from 'lucide-react';
import { useEffect } from 'react';

interface ThankYouDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const ThankYouDialog = ({ open, onOpenChange }: ThankYouDialogProps) => {
  useEffect(() => {
    if (open && typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('event', 'conversion', {
        send_to: 'AW-17888345899/9uLYCOvvofsbEKv-6dFC',
      });
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md bg-card border-border text-center p-10">
        <div className="flex flex-col items-center gap-5">
          <CheckCircle className="w-16 h-16 text-primary" />
          <h2 className="text-2xl md:text-3xl font-light">
            Thank you for your <span className="text-gradient-red">request!</span>
          </h2>
          <p className="text-muted-foreground">
            We'll get back to you within 24 hours via email.
          </p>
          <Button
            variant="outline"
            className="rounded-full h-12 px-8 mt-2"
            onClick={() => onOpenChange(false)}
          >
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ThankYouDialog;
